import panel from '@/core/routes/paths/panel'
import authentication from '@/core/routes/paths/authentication'
import errors from '@/core/routes/paths/errors'
import complaints from '@/core/routes/paths/complaints'


export default [
    ...panel,
    ...authentication,
    ...complaints,
     ...errors
]

